import classNames from "classnames";
import I18n from "@/i18n-js/instance";
import { TippyV2 } from "@circle-react/components/shared/TippyV2";
import { Icon } from "@circle-react-shared/Icon";
import { Typography } from "@circle-react-uikit/Typography";
import { ContextualMenu } from "./ContextualMenu";
import { FileWrapper } from "./FileWrapper";
import { getFileIcon, getFileType } from "./files_helper";

interface LessonFileProps {
  file: any;
  isDraggable?: boolean;
  shouldShowCheckmark?: boolean;
  shouldShowDropdown?: boolean;
}

export const LessonFile = ({
  file,
  isDraggable,
  shouldShowDropdown,
  shouldShowCheckmark,
}: LessonFileProps) => {
  const { filename: fileName, size } = file;
  const fileType = getFileType(file);
  const iconType = getFileIcon(fileType);

  return (
    <FileWrapper
      className={classNames("group h-16 px-6 py-3 hover:cursor-pointer", {
        "hover:bg-secondary hover:!cursor-grab": isDraggable,
      })}
      shouldShowDiv={shouldShowDropdown || shouldShowCheckmark}
      url={file.url}
    >
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2.5 break-all">
          <span className="flex items-center">
            <Icon type={iconType} size={20} className="text-default" />
          </span>
          <TippyV2 content={fileName} interactive={false}>
            <span className="grid min-w-0 items-center">
              <span className="text-dark truncate text-sm font-semibold">
                {fileName}
              </span>
            </span>
          </TippyV2>
        </div>

        {shouldShowCheckmark ? (
          <div className="ml-1 flex h-5 items-start">
            <span className="flex">
              <Icon
                type="20-checkmark-circle"
                size={20}
                className="text-v2-success"
              />
            </span>
          </div>
        ) : (
          shouldShowDropdown && <ContextualMenu file={file} />
        )}
      </div>

      <div className="ml-7 mt-1 flex h-4 select-none items-center gap-1 pl-0.5">
        <Typography.LabelXs color="text-default" textTransform="uppercase">
          {size}
        </Typography.LabelXs>
        <span className="text-default">{I18n.t("separator_dot")}</span>
        <Typography.LabelXs color="text-default" textTransform="uppercase">
          {fileType}
        </Typography.LabelXs>
      </div>
    </FileWrapper>
  );
};
